import React from "react";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Pagination } from "swiper/modules"; // Import modules
import "swiper/css";
import "swiper/css/navigation";
import "swiper/css/pagination";
import w5_2 from "../assets/w5_2.jpg";
import w5_3 from "../assets/w5_3.jpg";
import w5_4 from "../assets/w5_4.jpg";
import w5_5 from "../assets/w5_5.jpg";
import w5_6 from "../assets/w5_6.jpg";
import w5_7 from "../assets/w5_7.jpg";
import w5_8 from "../assets/w5_8.jpg";
import w5_9 from "../assets/w5_9.jpg";

const images = [w5_2, w5_3, w5_4, w5_5, w5_6, w5_7, w5_8, w5_9];

const ImageGallery = () => {
  return (
    <div className="w-full max-w-3xl mx-auto mt-8">
      <Swiper
        spaceBetween={10}
        slidesPerView={1}
        centeredSlides={true}
        pagination={{ clickable: true }}
        navigation={true}
        modules={[Navigation, Pagination]} // Add modules here
        style={{ width: "100%", height: "auto" }}
      >
        {images.map((img, index) => (
          <SwiperSlide key={index} style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
            <img
              src={img}
              alt={`Slide ${index + 1}`}
              style={{
                maxWidth: "100%",
                maxHeight: "100%",
                objectFit: "contain",
                aspectRatio: "16/9",
              }}
            />
          </SwiperSlide>
        ))}
      </Swiper>
    </div>
  );
};

export default ImageGallery;
